module.exports = __webpack_public_path__ + "static/media/logo-transparent.702ca13a.png";